import initVueApp from "@/core.js";
import router from "@/router";

const component = require(`./../views/Account.vue`).default;

initVueApp(component, router);
